import { Types } from 'mongoose'

export const ObjectId = Types.ObjectId
